export default {
    //德语
    DiagnosticReport:'Diagnose berichte',
    troubleCode:'Fehlercode',
    time:'Zeit',
    noTItle:'Kontrolle des Herstellers',
    TestReport:'Testbericht',
    VehicleInformation:'Fahrzeuginformationen',
    DataStream:'Datenstrom',
    IMReadiness:'I/M-Bereitschaft',
    Communication:'Kommunikationsprotokoll',
    notFaultCode:'Fehlerfreier Code',
    nodataflow:'Keine ungewöhnlichen Datenströme',
    // 语言
    lang:{
        cn:'chinesisch',
        de:'Deutsch',
        en:'Deutsch',
        es:'Spanisch',
        fr:'Französisch',
        it:'Italienisch',
        ja:'Japanisch',
        ko:'Koreanisch',
        pt:'Portugiesisch'
    }
}